module.exports = __webpack_public_path__ + "static/media/Paris Cam-3.ecd1ae6d.webp";